import axios from 'axios';
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { identity } from 'lodash';

import { useQueryParameter } from '@/contexts/QueryParametersContext';

import { Goal } from '../types';

export type ResponseData = {
  completionSvuValue?: number;
  goals: Array<Goal>;
};

export async function getGoals({ queryKey }: QueryFunctionContext) {
  const [, dateMonth] = queryKey;
  const response = await axios.get<ResponseData>('/api/goals', {
    params: { date_month: dateMonth },
  });
  return response.data;
}

export default function useGetGoals<TData = Array<Goal>>({
  enabled = true,
  select = (data: ResponseData) => data.goals as TData,
}: { enabled?: boolean; select?: (data: ResponseData) => TData } = {}) {
  const dateMonth = useQueryParameter('dateMonth');

  return useQuery({
    queryFn: getGoals,
    queryKey: ['goals', dateMonth],
    enabled,
    select,
  });
}

// This was added after the above hook. It contains more data than just the root goals.
export function useGetGoalsRoot<TData = ResponseData>({
  enabled = true,
  select = identity,
}: { enabled?: boolean; select?: (data: ResponseData) => TData } = {}) {
  const dateMonth = useQueryParameter('dateMonth');

  return useQuery({
    queryFn: getGoals,
    queryKey: ['goals', dateMonth],
    enabled,
    select,
  });
}
